<template>
    <header class="site-header-container">
        <HeaderAnimationNewBranding/>
        <div class="site-header">
            <HeaderNav></HeaderNav>
            <a class="bbe-logo" href="/">
                <img src="/images/logo-white.png" alt="Byblos Bank Europe">
            </a>
            <span class="contact-phone"></span>
        </div>
    </header>
</template>

<script>
import LanguageSwitcher from "./LanguageSwitcher";
import HeaderDevNav from "../Components/Header/HeaderDevNav";
import HeaderNav from "../Components/Header/HeaderNav";
import HeaderAnimationNewBranding from "../Components/Header/HeaderAnimationNewBranding";

export default {
    components: {HeaderAnimationNewBranding, HeaderNav, HeaderDevNav, LanguageSwitcher}
}
</script>

<style scoped>

</style>
